<template>
  <div>
    <table-manager
     @filterChanged="filterChanged"
     @paginationChanged="paginationChanged"
     @ClickOnAddButton="showAdd"
    :options="options"/>
    <basic-table
      v-if="AccountsGroups"
      :items="AccountsGroups"
      :fields="AccountsGroupsFields"
      @ClickOnEditButton="editItem"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isEdit="true"
      isDelete="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal ref="AccGroup"  :AccGroup="AccGroup" :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: false,
      perPageAccs: 20,
      AccountsGroupsFields: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      options: {
        isShowAddButton: true
      },
      AccGroup: {
        group_name: '',
        group_id: 0,
        accounts: []
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {

    deleteItem (item) {
      this.$store.dispatch('Users/DELETE_ACCOUNTS_GROUP', item.group_id)
      setTimeout(this.$store.dispatch, 500, 'Users/GET_ACCOUNTS_GROUPS')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Account Group?"', this.deleteItem, item)
    },
    showAdd () {
      this.isEdit = true
      this.isEdit = false
      this.AccGroup = {
        group_name: '',
        group_id: 0,
        accounts: []
      }
      this.$refs.AccGroup.ClearAccounts()
      this.$root.$emit('bv::show::modal', 'AccGroupRef', '#btnShow')
    },
    async editItem (item) {
      this.isEdit = false
      this.isEdit = true
      await this.$store.dispatch('Users/GET_ACCOUNTS_GROUP', item.group_id).then(el => {
        this.AccGroup = JSON.parse(JSON.stringify(this.$store.getters['Users/ACCOUNTS_GROUP']))
        this.$refs.AccGroup.SetAccounts(this.AccGroup.accounts)
      })
      this.$root.$emit('bv::show::modal', 'AccGroupRef', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  watch: {
    perPage: function () {
      this.currentPage = 1
    }
  },
  computed: {

    AccountsGroups () {
      return this.$store.getters['Users/ACCOUNTS_GROUPS']
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_ACCOUNTS_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accountsGroups/main.vue